// extracted by mini-css-extract-plugin
module.exports = {"abas":"Abas_abas__20ONQ","aba":"Abas_aba__2LeNo","icone":"Abas_icone__2ot-r","ativo":"Abas_ativo__1_IwN"};